module.exports = __webpack_public_path__ + "static/media/Q1Mob.64dee92c.png";